module.exports = __webpack_public_path__ + "static/media/icon-social--tw.e253db00.svg";